/**
 * Purchase order detail — document view + status-gated actions.
 *
 * @see prototype/purchases/purchase-order-detail.html — V1.1 baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { PoDetailPage } from "../../../../features/purchase-orders/index.ts";

export const Route = createFileRoute("/(workspace)/procurement/purchase-orders/$poId/")({
  component: PurchaseOrderDetailRoute,
});

function PurchaseOrderDetailRoute() {
  const { poId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Purchase orders", to: "/procurement/purchase-orders" },
        { label: "Detail" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <PoDetailPage poId={poId} />
    </WorkspaceShell>
  );
}
